import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#A8ACBD",
  d: "M3 10.672c0 2.141 1.697 3.876 3.79 3.876H8.6l1.51-4.082h4.59l-1.05 3.091h2.85l-.68.991h1.912c1.805 0 3.268-1.496 3.268-3.342 0-1.847-1.463-3.343-3.268-3.343-.191 0-.377.02-.56.052-.292-2.452-2.334-4.352-4.811-4.352l-.048.001-.048.002c-2.091.042-3.858 1.436-4.496 3.364a3.715 3.715 0 0 0-.978-.135C4.697 6.795 3 8.531 3 10.672Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A000",
  fillRule: "evenodd",
  d: "M10.68 11.233h2.88l-1.08 3.107H15l-4.32 6.098.84-4.402H9l1.68-4.803Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=StormIcon24.js.map